var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column",staticStyle:{"height":"100vh"}},[(_vm.isDev)?_c('appNav'):_vm._e(),_c('b-container',{staticClass:"mb-5",attrs:{"id":"main-container"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }